<template>
  <i :class="faIcon"></i>
</template>

<script>

const normalizeFileTypes =
    ["audio", "video", "image", "csv", "doc", "eps",
      "pdf", "ppt", "txt", "xls", "zip", "flash"]

const iconByFileTypes = {};
iconByFileTypes["image"] = "fa-image";
iconByFileTypes["audio"] = "fa-music";
iconByFileTypes["video"] = "fa-film";
iconByFileTypes["doc"] = "fa-file-word";
iconByFileTypes["pdf"] = "fa-file-pdf";
iconByFileTypes["ppt"] = "fa-file-powerpoint";
iconByFileTypes["txt"] = "fa-file-text";
iconByFileTypes["xls"] = "file-excel";
iconByFileTypes["zip"] = "fa-file-zip";
iconByFileTypes["flash"] = "fa-bolt";
iconByFileTypes["file"] = "fa-file";

export default {
  name: "FilePreviewIcon",
  props: {
    pFileType: {
      type: String,
      default: function () {
        return '';
      }
    }
  },
  computed: {
    normalizedFileType: function () {
      for(let i = 0; i < normalizeFileTypes.length; i++)
      {
        let fileType = normalizeFileTypes[i];
        if(this.pFileType.includes(fileType))
        {
          return fileType;
        }
      }
      return null;
    },
    faIcon: function () {
      return "fa " + (iconByFileTypes[this.normalizedFileType] || "fa-file");
    }
  }
}
</script>

<style scoped>

</style>